import { NoticeRow } from '@models/notice';
import dayjs from 'dayjs';

import BoardCard from '../../BoardCard';

interface Props {
    notice: NoticeRow;
}

function NoticeItem({ notice }:Props) {
    const {
        title, content, createdAt, isPinned,
    } = notice;

    const parsed = document.createElement('div');
    parsed.innerHTML = content;
    const imageOnly = parsed.textContent?.length === 0
        && parsed.querySelectorAll('img').length !== 0;
    const imageUrl = imageOnly
        ? parsed.querySelector('img')?.getAttribute('src')
        : null;
    const contentSummary = parsed.textContent?.slice(0, 50);
    return (
        <BoardCard activityName='NoticeActivity'
            activityParams={{ noticeId: notice.id }}
            meta={dayjs(createdAt).format('YYYY.MM.DD')}
            isPinned={isPinned}
            title={title}
            imageUrl={imageUrl}
            summary={contentSummary} />
    );
}

export default NoticeItem;
